export default function FinalCTA() {
  return (
    <section className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-4">Ready to Start?</p>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-5 leading-tight">
          Get Your Helena Passport Fast — No Denver Trip Required
        </h2>
        <p className="text-white/60 text-base leading-relaxed max-w-2xl mx-auto mb-10">
          Join thousands of Montana travelers who trust Fast Passport Center. A registered State Department courier service with 20+ years of experience — delivering passports in as fast as 2–9 business days.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Helena Passport <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 border border-white/30 hover:border-white text-white font-semibold text-sm px-6 py-4 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> 877-253-0084
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { icon: "ri-star-fill", text: "4.9 / 5 Rating" },
            { icon: "ri-award-line", text: "A+ BBB Rating" },
            { icon: "ri-shield-check-line", text: "Registered State Dept. Courier" },
            { icon: "ri-calendar-check-line", text: "20+ Years Experience" },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2 text-white/60 text-sm">
              <i className={`${item.icon} text-[#F6C344] text-base`}></i>
              <span>{item.text}</span>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-10 border-t border-white/10">
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-white/40 text-xs">
            <a href="/states/montana" className="hover:text-white/60 transition-colors whitespace-nowrap">Montana State Hub</a>
            <span>&middot;</span>
            <a href="/cities/billings" className="hover:text-white/60 transition-colors whitespace-nowrap">Billings</a>
            <span>&middot;</span>
            <a href="/cities/missoula" className="hover:text-white/60 transition-colors whitespace-nowrap">Missoula</a>
            <span>&middot;</span>
            <a href="/cities/bozeman" className="hover:text-white/60 transition-colors whitespace-nowrap">Bozeman</a>
            <span>&middot;</span>
            <a href="/cities/great-falls" className="hover:text-white/60 transition-colors whitespace-nowrap">Great Falls</a>
            <span>&middot;</span>
            <a href="https://fastpassportcenter.com" className="hover:text-white/60 transition-colors whitespace-nowrap">FastPassportCenter.com</a>
          </div>
          <p className="mt-6 text-white/20 text-xs">
            &copy; {new Date().getFullYear()} Fast Passport Center. All rights reserved. Fast Passport Center is a registered courier service authorized to submit passport applications to U.S. Regional Passport Agencies.
          </p>
        </div>
      </div>
    </section>
  );
}